import React, { Component } from 'react';
import { connect } from 'react-redux';
import { editObject, addNewImage, toggleLoading } from "../../actions";
// import ChoiceWidget from '../../components/ChoiceWidget';
import Uppy from '@uppy/core';
import { DragDrop } from '@uppy/react';
import XHRUpload from '@uppy/xhr-upload';

class ImagePane extends Component {

  constructor(props) {
    super(props);

    this.renderNew = this.renderNew.bind(this);
    this.renderEdit = this.renderEdit.bind(this);
  }

  componentWillMount() {
    this.uppy = new Uppy({
      restrictions: {
        allowedFileTypes: ['.jpg', '.jpeg', '.png', '.gif', '.ai', '.psd', '.svg']
      },
      autoProceed: true
    });

    this.uppy.use(XHRUpload, {
      endpoint: window.tProjectGlobals.baseUrl + '/designer/upload',
      method: 'post',
      formData: true,
      fieldName: 'files'
    });

    this.uppy.on('upload', () => {
      this.props.toggleLoading(true);
    })

    this.uppy.on('upload-success', (file, {body}) => {
      //console.log(file, body);
      this.props.addNewImage({
        src: body.url,
        width: body.width,
        height: body.height,
        name: body.name
      });
    });
  }

  renderNew() {
    return (
      <div className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
        <div className="t-container-sidebar-content">
          <h3>画像の追加</h3>

          <div className="t-container-sidebar-uppy">
            <div className="t-container-sidebar-uppy-inside">
              <DragDrop uppy={this.uppy} note="対応形式: JPEG, PNG, GIF, AI, PSD, SVG" locale={{
                strings: {
                  dropHereOr: '画面に画像をドロップするか、%{browse}してください。',
                  // Used as the label for the link that opens the system file selection dialog.
                  browse: 'ファイルから選択'
                }
              }} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderEdit(object) {
    return (
      <div className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
        <div className="t-container-sidebar-content">
          <h3>画像の編集</h3>

          <div className="t-container-sidebar-image">
            <img src={object.src} alt={object.name} />
          </div>
        </div>
      </div>
    )
  }

  render() {
    if (this.props.sidebar.object && this.props.sidebar.object.type === 'image') {
      const surfaceId = this.props.objects.present.currentSurface.surface.id;
      const object = this.props.objects.present.objects[surfaceId][this.props.layers.selected[0]];

      if (object) {
        return this.renderEdit(object);
      }
    }

    return this.renderNew();
  }
}

ImagePane = connect(f => f, {addNewImage, editObject, toggleLoading})(ImagePane);

export default ImagePane;


// WEBPACK FOOTER //
// ./src/components/Sidebar/ImagePane.js